import axios from 'axios'
import apiService from '../apiService'

const api_path = '/default'
const api_path_22 =
	'https://fininsurance.co.th:2022/api/v1/insurance/default'

export const defaultController = (configService) => {
	const service = apiService(configService)
	return {
		getConstant: (filter) => {
			return axios
				.get(`${api_path_22}/constant`, {
					headers: { app_type: 'B2B-PLUS' },
					params: filter ? { filter } : {},
				})
				.then((res) => res.data)
				.catch((err) => err?.response?.data)
		},
		getTitle: () => {
			return service.get({
				url: `${api_path}/title`,
			})
		},
		getTypeInsurance: () => {
			return service.get({
				url: `${api_path}/detail_code`,
			})
		},
		getAutoScene: () => {
			return service.get({
				url: `${api_path}/auto_scene`,
			})
		},
		getDetailCodeScene: () => {
			return service.get({
				url: `${api_path}/detail_code`,
			})
		},
		getCarTypePrb: () => {
			return service.get({
				url: `${api_path}/car_type_prb`,
			})
		},
		getBank: () => {
			return service.get({
				url: `${api_path}/get-bank-pay`,
			})
		},
		getCountryThaisri: () => {
			return service.get({
				url: `${api_path}/get-country-thaisri`,
			})
		},
		getNationalThaisri: () => {
			return service.get({
				url: `${api_path}/get-national-thaisri`,
			})
		},
		getNationalKwi: () => {
			return service.get({
				url: `${api_path}/get-national-kwi`,
			})
		},
    getCountryDj: () => {
			return service.get({
				url: `${api_path}/get-country-dj`,
			})
		},
		getNationalityDj: () => {
			return service.get({
				url: `${api_path}/get-national-dj`,
			})
		},
		getEmailNewgroup: (fin_new_group) => {
			return service.get({
				url: `${api_path}/get-email-new-group?fin_new_group=${fin_new_group}`,
			})
		},
		getPackageTypeDvs: () => {
			return service.get({
				url: `${api_path}/get-package-type-dvs`,
			})
		},
	}
}
